//import "babel-polyfill";
import {ComponentsLoader} from './helpers/components-loader';

function App() {
    const page = document.querySelector('main').getAttribute('data-page');
    new ComponentsLoader(page);
}

new App();
